import { Text, View } from 'react-native'

import { convertLineHeight, styled } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      paddingTop: theme.paddingInsetThreepulse,
      gap: theme.spacingInlineThreepulse,

      backgroundColor: 'transparent',
    },
    variants: {},
  }
})

export const Wrapper = styled(View, theme => {
  return {
    base: {
      paddingVertical: theme.paddingInsetTwopulse,
      paddingHorizontal: theme.paddingInsetFivepulse,
    },
    variants: {},
  }
})

export const Title = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.bold,
      fontSize: theme.fontSizeThreeandhalfpulse,
      color: theme.colorTextNeutralReadonly,

      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {},
  }
})
